import { Typography } from "@mui/material";
import PayloadParse from "../components/PayloadParse/index";
import CustomSnackbar from "../components/Common/CustomSnackbar";
import { useParserConfigDetail } from "./hooks/useParserConfigDetail";
import { useQueryParamLegacy } from "./hooks/useQueryParam";
import { useSnackbar } from "../components/Common/hooks/useSnackbar";

const ParserDetail = () => {
  const { snackbarProps } = useSnackbar();

  const parserConfigId = useQueryParamLegacy("id");
  const deviceTypeId = useQueryParamLegacy("deviceTypeId");

  const { selectedRow, loading } = useParserConfigDetail(parserConfigId);

  return (
    <>
      <div className="panel-container">
        {selectedRow?.name && (
          <Typography variant="subtitle1" fontWeight={600} sx={{ color: "#374151", mb: 1 }}>
            {selectedRow.name}
          </Typography>
        )}

        {loading ? (
          <Typography>Yükleniyor...</Typography>
        ) : (
          selectedRow && (
            <PayloadParse
              selectedParserConfig={selectedRow.id}
              payloadTypeId={selectedRow.payloadTypeId}
              deviceTypeId={Number(deviceTypeId)}
            />
          )
        )}
      </div>

      <CustomSnackbar {...snackbarProps} />
    </>
  );
};

export default ParserDetail;
